import Image from 'next/image';
import Link from 'next/link';

import ArrowIcon from 'static/icons/arrow_without_tail.svg';
import classes from './ArrowLink.module.css';

type Props = {
   href: string;
   text: string;
};

const ArrowLink = ({ href, text }: Props) => (
   <Link href={href}>
      <a className={classes.arrowLink}>
         <span>{text}</span>
         <span className={classes.arrow}>
            <Image src={ArrowIcon} layout="responsive" alt="" />
         </span>
      </a>
   </Link>
);

export default ArrowLink;
